import { render, staticRenderFns } from "./DocumentsWrapper.vue?vue&type=template&id=583d82e1"
import script from "./DocumentsWrapper.vue?vue&type=script&lang=js"
export * from "./DocumentsWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports